import { useQuery } from '@tanstack/react-query'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'

import type { PolicyVersionList } from '@/dtos/exceptionalDiscount'
import { Apis } from '../appSettings/AppSettings'
import { useUrl } from '.'

export const policyVersionsQueryKey = (insuranceId: number | undefined) => ['policyVersions', insuranceId]

export const usePolicyVersions = (insuranceId: number | undefined) => {
  const url = useUrl(Apis.exceptionalDiscount)

  return useQuery({
    queryKey: policyVersionsQueryKey(insuranceId),
    queryFn: () =>
      apiClient
        .get<PolicyVersionList>(`${url}/GetPolicyVersions`, { params: { insuranceId } })
        .then(r => r.data),
    enabled: !!insuranceId,
  })
}
